
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import "../Bunch.css";

const Kiosks = (props) => {
    const item = props.kiosk;
    return (
        <div className="row justify-content-center w-100 mt-2">
            <div className="kiosk-row">
                <div className="row">
                    <div className="col-3">
                        <FormControlLabel
                            onChange={(event) => { props.chooseKiosk(event, item.id) }}
                            control={< Checkbox checked={!!props.selectedKiosks && props.selectedKiosks.filter(k => k.id === item.id).length > 0} />}
                            label=""
                        />
                    </div>
                    <div className="col-8 pt-3">
                        نام لاکز: {item.description}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Kiosks;